export const DEFAULT_VECTOR_STYLES_URL =
  'https://js.api.here.com/v3/3.1/styles/omv/miami/normal.day.yaml';

export const TRUCK_VECTOR_STYLES_URL =
  'https://js.api.here.com/v3/3.1/styles/omv/miami/truck.day.yaml';

export const DEFAULT_MAP_CENTER = { lat: 52.527964, lng: 13.394179 };

export const DEFAULT_ZOOM = 13;

export const getTrafficLayerStyles = () => ({
  sources: {
    traffic: {
      type: 'OMV',
      max_zoom: 20,
      min_display_zoom: 1,
    },
  },
  textures: {
    road_works_red: {
      // eslint-disable-next-line max-len
      url: 'data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2226%22%20height%3D%2233%22%20enable-background%3D%22new%200%200%2026%2033%22%20viewBox%3D%220%200%2026%2033%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22m26%2033h-26v-33h26z%22%20fill%3D%22%238c8c8c%22%20opacity%3D%220%22%2F%3E%3Cpath%20d%3D%22m17%2029.566c0%201.116-1.791%202.022-4%202.022s-4-.906-4-2.022c0-1.118%201.791-2.026%204-2.026s4%20.908%204%202.026%22%20fill%3D%22%23878787%22%20opacity%3D%22.6%22%2F%3E%3Cpath%20d%3D%22m1.795%2017.971c-1.562-1.555-1.574-3.828-.028-5.655l8.343-10.021c.769-.895%201.795-1.384%202.894-1.384%201.117%200%202.197.521%202.889%201.394l8.338%2010.014c1.588%201.854%201.578%204.022-.029%205.65l-11.202%2011.202z%22%20fill%3D%22%23d5232f%22%2F%3E%3Cpath%20d%3D%22m13.004%201.411c.964%200%201.894.441%202.496%201.204l8.346%2010.023c1.363%201.592%201.482%203.477%200%204.979l-10.846%2010.847-10.852-10.846c-1.381-1.375-1.379-3.348%200-4.979l8.346-10.023c.717-.835%201.628-1.205%202.51-1.205m0-1c-1.248%200-2.408.551-3.268%201.552l-8.356%2010.035c-1.718%202.033-1.695%204.578.064%206.328l10.85%2010.845.706.707.707-.707%2010.846-10.846c1.784-1.808%201.803-4.293.053-6.337l-8.337-10.012c-.769-.973-1.996-1.565-3.265-1.565zm-.575%2015.264c.018-.332-.13-.651-.394-.851l-2.945-2.235-.21.36c-.22.39-.41.78-.58%201.19l-.677%202.129-1.364%203.051h1.314l2.109-4.672%201.317%201.212.138%203.46h1.092zm6.16-1.327c-.401-.54-1.209-.539-1.609.001l-1.17%201.58-2.29-1.74-.139-4.054c-.011-.276-.134-.535-.342-.716l-.7-.61c-.185-.161-.422-.25-.667-.25h-1.885c-.335%200-.648.168-.833.447l-1.144%201.723%207.58%205.76-1.86%202.51c-.098.132-.004.32.161.32h6.648l1.142-1.077zm-8.79-2.989-.876-.665.841-1.018.965.043zm1.63%201.24.969-1.781.118%202.61zm2.76-5.79c-.64%200-1.16.52-1.16%201.16%200%20.65.52%201.17%201.16%201.17s1.16-.52%201.16-1.17c0-.64-.52-1.16-1.16-1.16z%22%20fill%3D%22%23fff%22%2F%3E%3C%2Fsvg%3E',
    },
    alert: {
      // eslint-disable-next-line max-len
      url: 'data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2226%22%20height%3D%2233%22%20enable-background%3D%22new%200%200%2026%2033%22%20viewBox%3D%220%200%2026%2033%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22m26%2033h-26v-33h26z%22%20fill%3D%22%238c8c8c%22%20opacity%3D%220%22%2F%3E%3Cpath%20d%3D%22m17%2029.566c0%201.116-1.791%202.022-4%202.022s-4-.906-4-2.022c0-1.118%201.791-2.026%204-2.026s4%20.908%204%202.026%22%20fill%3D%22%23878787%22%20opacity%3D%22.6%22%2F%3E%3Cpath%20d%3D%22m1.795%2017.971c-1.562-1.555-1.574-3.828-.028-5.655l8.343-10.021c.769-.895%201.795-1.384%202.894-1.384%201.117%200%202.197.521%202.889%201.394l8.338%2010.014c1.588%201.854%201.578%204.022-.029%205.65l-11.202%2011.202z%22%20fill%3D%22%23323232%22%2F%3E%3Cpath%20style%3D%22fill%3A%23FFFFFF%3B%22%20d%3D%22M13.004%2C1.411c0.964%2C0%2C1.894%2C0.441%2C2.496%2C1.204l8.346%2C10.023c1.363%2C1.592%2C1.482%2C3.477%2C0%2C4.979L13%2C28.465L2.148%2C17.618c-1.381-1.375-1.379-3.348%2C0-4.979l8.346-10.023C11.211%2C1.781%2C12.122%2C1.411%2C13.004%2C1.411%20M13.004%2C0.411L13.004%2C0.411c-1.248%2C0-2.408%2C0.551-3.268%2C1.552L1.38%2C11.998c-1.718%2C2.033-1.694%2C4.579%2C0.064%2C6.328l10.85%2C10.845L13%2C29.878l0.707-0.707l10.846-10.846c1.784-1.808%2C1.803-4.293%2C0.053-6.337L16.269%2C1.976C15.5%2C1.003%2C14.273%2C0.411%2C13.004%2C0.411L13.004%2C0.411z%20M14.716%2C20.139c0%2C0.947-0.758%2C1.724-1.724%2C1.724c-0.947%2C0-1.704-0.777-1.704-1.724c0-0.928%2C0.757-1.704%2C1.704-1.704C13.958%2C18.435%2C14.716%2C19.211%2C14.716%2C20.139z%20M14.204%2C16.33H11.78l-0.537-8.533h3.5L14.204%2C16.33z%22%2F%3E%3C%2Fsvg%3E',
    },
    congestion: {
      // eslint-disable-next-line max-len
      url: 'data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22100%22%20height%3D%22125%22%20viewBox%3D%220%200%20100%20125%22%3E%3Cpath%20fill%3D%22%23fff%22%20d%3D%22M50%2020l40%2065H15z%22%2F%3E%3Cpath%20fill%3D%22red%22%20d%3D%22M94.6%2085.2L52.4%2012c-1.1-1.9-3.8-1.7-4.8%200L5.4%2085.2c-1.1%201.8.3%204.2%202.4%204.2h84.5c2.1-.1%203.3-2.4%202.3-4.2zM17.4%2081L50%2024.5%2082.6%2081H17.4z%22%2F%3E%3Cpath%20d%3D%22M73.8%2072v-2.5h-1.1l-2.6-5h-6.4v-.9h2.5v-2.5h-1.1l-2.6-5h-6.4V55h2.5v-2.5h-1.1l-2.6-5h-16l-2.6%205h-1.1V55h2.5v1h-2.5v.6h2.5v1h-2.5v2.5h2V62h4.4v-1.9h2.7l-.4.8h-1.1v2.5h2.5v1h-2.5v.6h2.5v1h-2.5v2.5h1.9v1.9h4.4v-1.9h2.7l-.4.8h-1.1v2.5h2.5v1h-2.5v.6h2.5v1h-2.5v2.5h1.9V79h4.4v-1.9h10.8V79h4.4v-1.9h1.9v-2.5h-2.5v-1h2.5V73h-2.5v-1h2.6zM38.5%2052.5l1.9-3.8h13.2l1.9%203.8h-17zm4.5%205.1V55h8v.9h-4.5l-.9%201.7H43zm3%203.3l1.9-3.8h13.2l1.9%203.8H46zm4.6%205.2v-2.6h7.9v.9H54l-.9%201.7h-2.5zm15.5%208.4h-7.9V72h7.9v2.5zm-12.5-5.1l1.9-3.8h13.2l1.9%203.8h-17z%22%2F%3E%3C%2Fsvg%3E',
    },
    accident: {
      // eslint-disable-next-line max-len
      url: 'data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2226%22%20height%3D%2233%22%20enable-background%3D%22new%200%200%2026%2033%22%20viewBox%3D%220%200%2026%2033%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22m26%2033h-26v-33h26z%22%20fill%3D%22%238c8c8c%22%20opacity%3D%220%22%2F%3E%3Cpath%20d%3D%22m17%2029.566c0%201.116-1.791%202.022-4%202.022s-4-.906-4-2.022c0-1.118%201.791-2.026%204-2.026s4%20.908%204%202.026%22%20fill%3D%22%23878787%22%20opacity%3D%22.6%22%2F%3E%3Cpath%20d%3D%22m1.795%2017.971c-1.562-1.555-1.574-3.828-.028-5.655l8.343-10.021c.769-.895%201.795-1.384%202.894-1.384%201.117%200%202.197.521%202.889%201.394l8.338%2010.014c1.588%201.854%201.578%204.022-.029%205.65l-11.202%2011.202z%22%20fill%3D%22%23d5232f%22%2F%3E%3Cpath%20style%3D%22fill%3A%23FFFFFF%3B%22%20d%3D%22M12.998%2C1.091c0.964%2C0%2C1.894%2C0.442%2C2.496%2C1.204l8.346%2C10.344c1.363%2C1.592%2C1.482%2C3.477%2C0%2C4.979L12.994%2C28.465L2.143%2C17.618c-1.381-1.375-1.379-3.348%2C0-4.979l8.346-10.344C11.205%2C1.462%2C12.115%2C1.091%2C12.998%2C1.091%20M12.998%2C0.091L12.998%2C0.091c-1.248%2C0-2.408%2C0.551-3.269%2C1.552L1.364%2C12.011c-1.708%2C2.021-1.685%2C4.566%2C0.073%2C6.316l10.85%2C10.845l0.707%2C0.707l0.707-0.707l10.846-10.846c1.784-1.808%2C1.803-4.293%2C0.053-6.337l-8.327-10.32C15.494%2C0.684%2C14.268%2C0.091%2C12.998%2C0.091L12.998%2C0.091z%20M7.83%2C18.982l-3.309-1.855l0.945%2C1.855H7.83z%20M16.111%2C19h3.942l1.596-2L16.111%2C19z%20M10.512%2C20.064l1.021-1.021l1.632%2C0.076c0.329%2C0.018%2C0.651-0.022%2C0.963-0.123c0.626-0.206%2C1.122-0.76%2C1.288-1.44l0.264-1.089l2.066-0.93c0.373-0.17%2C0.673-0.42%2C0.861-0.731c0.275-0.449%2C0.405-0.97%2C0.369-1.498L18.9%2C11.676l1.021-1.021l-0.724-0.724l-0.427%2C0.427l-0.121-0.364c-0.201-0.603-0.54-1.151-0.989-1.6l-1.159-1.159c-0.5-0.5-1.31-0.5-1.809%2C0l-1.267%2C1.267l0.724%2C0.724l-5.066%2C5.066l-0.724-0.724l-1.267%2C1.267c-0.5%2C0.5-0.5%2C1.31%2C0%2C1.809l1.159%2C1.159c0.449%2C0.449%2C0.997%2C0.788%2C1.6%2C0.989l0.364%2C0.121l-0.427%2C0.427L10.512%2C20.064z%20M14.901%2C10.349l0.732-0.732c0.098-0.098%2C0.256-0.098%2C0.354%2C0l0.732%2C0.732c0.098%2C0.098%2C0.098%2C0.256%2C0%2C0.354l-0.732%2C0.732c-0.098%2C0.098-0.256%2C0.098-0.354%2C0l-0.732-0.732C14.803%2C10.604%2C14.803%2C10.446%2C14.901%2C10.349z%20M9.472%2C15.777l0.732-0.732c0.098-0.098%2C0.256-0.098%2C0.354%2C0l0.732%2C0.732c0.098%2C0.098%2C0.098%2C0.256%2C0%2C0.354l-0.732%2C0.732c-0.098%2C0.098-0.256%2C0.098-0.354%2C0L9.472%2C16.13C9.375%2C16.033%2C9.375%2C15.874%2C9.472%2C15.777z%20M11.391%2C17.615c0.069-0.271%2C0.206-0.518%2C0.405-0.717l4.961-4.961c0.195-0.195%2C0.445-0.337%2C0.717-0.405l0.344-0.083l0.137%2C1.925c0.022%2C0.318-0.058%2C0.63-0.221%2C0.901c-0.101%2C0.166-0.279%2C0.271-0.409%2C0.329L14.8%2C15.74l-0.38%2C1.574c-0.083%2C0.344-0.318%2C0.615-0.612%2C0.713c-0.188%2C0.058-0.38%2C0.083-0.579%2C0.072l-1.925-0.138L11.391%2C17.615z%22%2F%3E%3C%2Fsvg%3E',
    },
    road_closure: {
      // eslint-disable-next-line max-len
      url: 'data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20width%3D%22416.979px%22%20height%3D%22416.979px%22%20viewBox%3D%220%200%20416.979%20416.979%22%20style%3D%22enable-background%3Anew%200%200%20416.979%20416.979%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Ccircle%20cx%3D%22208.49%22%20cy%3D%22208.49%22%20r%3D%22208.49%22%20fill%3D%22white%22%20%2F%3E%3Cpath%20fill%3D%22red%22%20d%3D%22M356.004%2C61.156c-81.37-81.47-213.377-81.551-294.848-0.182c-81.47%2C81.371-81.552%2C213.379-0.181%2C294.85%20c81.369%2C81.47%2C213.378%2C81.551%2C294.849%2C0.181C437.293%2C274.636%2C437.375%2C142.626%2C356.004%2C61.156z%20M332.156%2C235.874%20c-0.003%2C6.466-5.246%2C11.702-11.711%2C11.697l-223.96-0.138c-6.465-0.003-11.702-5.248-11.697-11.711l0.034-54.618%20c0.003-6.466%2C5.245-11.701%2C11.71-11.698l223.962%2C0.14c6.465%2C0.003%2C11.701%2C5.247%2C11.697%2C11.711L332.156%2C235.874z%22%2F%3E%3C%2Fsvg%3E',
    },
  },
  layers: {
    traffic_flow: {
      data: {
        source: 'traffic',
        layer: 'traffic_flow',
      },
      draw: {
        lines: {
          width: '4px',
          order: 1,
          miter_limit: 2,
          offset: '4px',
        },
      },
      drives_on_left: {
        filter: {
          drives_on_left: 1,
        },
        draw: {
          lines: {
            offset: '-4px'
          },
        },
      },
      free: {
        filter: {
          kind: 'free',
        },
        draw: {
          lines: {
            color: '#00ff00',
          },
        },
      },
      minor: {
        filter: {
          kind: 'minor',
        },
        draw: {
          lines: {
            color: '#aaaa00',
          },
        },
      },
      slow: {
        filter: {
          kind: 'slow',
        },
        draw: {
          lines: {
            color: '#ffdd00',
          },
        },
      },
      stationary: {
        filter: {
          kind: 'stationary',
        },
        draw: {
          lines: {
            color: '#ff0000',
          },
        },
      },
      queuing: {
        filter: {
          kind: 'queuing',
        },
        draw: {
          lines: {
            color: '#ff0000',
          },
        },
      },
      none: {
        filter: {
          kind: 'none',
        },
        draw: {
          lines: {
            color: '#000000',
          },
        },
      },
    },
    traffic_incidents: {
      data: {
        source: 'traffic',
        layer: 'traffic_incidents',
      },
      draw: {
        lines: {
          width: '4px',
          order: 2,
          miter_limit: 2,
          offset: '4px',
          dash: [3, 3],
          color: 'orange',
        },
      },
      drives_on_left: {
        filter: {
          drives_on_left: 1,
        },
        draw: {
          lines: {
            offset: '-4px',
          },
        },
      },
      road_closure: {
        filter: {
          kind: 'road_closure',
        },
        draw: {
          lines: {
            color: '#000000',
            dash: null,
          },
        },
      },
    },
    incident_icons: {
      data: {
        source: 'traffic',
        layer: 'traffic_incidents',
      },
      draw: {
        points: {
          texture: 'alert',
          priority: 2,
          size: [30, 40],
          offset: [0, -15],
        },
      },
      construction: {
        filter: {
          kind: ['construction'],
        },
        draw: {
          points: {
            texture: 'road_works_red',
            priority: 2,
            size: [40, 40],
            offset: [0, -20],
          },
        },
      },
      congestion: {
        filter: {
          kind: ['congestion'],
        },
        draw: {
          points: {
            texture: 'congestion',
            priority: 2,
            size: [50, 70],
            offset: [0, -20],
          },
        },
      },
      accident: {
        filter: {
          kind: ['accident'],
        },
        draw: {
          points: {
            texture: 'accident',
            priority: 2,
            size: [30, 40],
            offset: [0, -20],
          },
        },
      },
      road_closure: {
        filter: {
          kind: ['road_closure'],
        },
        draw: {
          points: {
            texture: 'road_closure',
            priority: 2,
            size: [30, 30],
            offset: [-15, -15],
          },
        },
      },
    },
  },
});
